// extracted by mini-css-extract-plugin
export default {"iconSAP":"SapStatus_iconSAP__Ex4bD"};